export const ru = {
    adaptive: 'Адаптивный креатив',
    'adaptive-disclaimer':
        'Идея нового адаптивного объявления, которое автоматически подстраивается под нужный рекламный блок на площадке.',
    'adaptive-info':
        'Ваше изображение для креатива должно соответствовать следующим техническим требованиям: максимальное разрешение не более 1500х800 пикселей (изображения большего размера будут сжаты), размер изображения после сжатия не должен превышать 512 кБ.',
    'apply-adaptive': 'Попробовать!',
    'create-banners': 'Создать',
    'empty-message':
        'Здесь пока нет идей креативов. Укажите URL страницы сайта, и конструктор сгенерирует идеи креативов на основе ее содержимого.',
    'progress-message': 'Загружаем содержимое страницы',
    'progress-message1': 'Продолжаем загрузку содержимого страницы',
    'progress-message2':
        'Продолжаем загрузку содержимого страницы. Возможно, создается много идей, или сайт отвечает медленно',
    'url-placeholder': 'URL страницы вашего сайта'
};
